import { EOrganizationStatus } from "@/constants/enum";
import { background, black, state } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

const STATUS_CONFIG: Record<EOrganizationStatus, { label: string; color: string }> = {
  [EOrganizationStatus.ACTIVE]: { label: "利用中", color: state.active },
  [EOrganizationStatus.ARCHIVED]: { label: "アーカイブ済", color: state.pending },
  [EOrganizationStatus.DELETED]: { label: "データ削除済", color: state.error },
};

type Props = {
  status: string;
};

export const OrganizationStatusTag: FC<Props> = ({ status }) => {
  const config = STATUS_CONFIG[status as EOrganizationStatus] ?? { label: status, color: background.disable };
  return (
    <Stack
      sx={{
        backgroundColor: config.color,
        padding: "4px 20px",
        borderRadius: "16px",
      }}
    >
      <Typography variant="cap12" color={black[30]}>
        {config.label}
      </Typography>
    </Stack>
  );
};
